import React from 'react';
import './ReasonsBox.scss';
import { Alert } from '@mui/material';

interface ReasonsBoxProps {
  reasons: string[];
}

const ReasonsBox: React.FC<ReasonsBoxProps> = ({ reasons }) => (
  <div className="reasons-box__wrapper">
    <Alert
      severity="warning"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        border: '1px solid rgba(0, 0, 0, 0.12)',
      }}
    >
      <div className="reasons-box__container">
        <div className="reasons-box__list">
          {reasons.map(reason => (
            <div key={reason} className="reasons-box__list-item">
              {reason}
            </div>
          ))}
        </div>
      </div>
    </Alert>
  </div>
);

export default ReasonsBox;
